import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import { formatDate } from '../../../config/appConfig';
import { useCrewList } from '../../crew/useData';
import type { CrewListItem } from '../../crew/types';
import GenericListWidget from './GenericListWidget';

const CrewRecent: React.FC<{ limit?: number; embedded?: boolean; settings?: Record<string, unknown> }> = ({
  limit = 6,
  embedded,
  settings,
}) => {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const effectiveLimit = typeof settings?.limit === 'number' ? settings.limit : limit;
  const { data, isLoading } = useCrewList(undefined, 1, effectiveLimit, {
    sortKey: 'updatedAt',
    sortDirection: 'desc',
  });

  return (
    <GenericListWidget<CrewListItem>
      title="Crew · Recent"
      viewAllPath="/crew"
      data={data ?? []}
      isLoading={isLoading}
      limit={effectiveLimit}
      emptyMessage="No crew records"
      getItemKey={(row) => row.id}
      embedded={embedded}
      renderItem={(row) => {
        const name = [row.lastName, row.firstName].filter(Boolean).join(', ');
        const rank = row.rank?.name ?? row.rank?.abrv ?? '—';
        return (
          <div
            onClick={() => navigate(`/crew/${row.id}`)}
            className="flex items-center justify-between gap-3 p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/40 cursor-pointer"
          >
            <div className="min-w-0">
              <p className={`text-sm font-medium truncate ${colors.text}`}>{name || `Crew #${row.id}`}</p>
              <p className={`text-xs ${colors.textMuted}`}>{rank}</p>
            </div>
            <span className={`text-xs whitespace-nowrap ${colors.textMuted}`}>
              {formatDate(row.updatedAt)}
            </span>
          </div>
        );
      }}
    />
  );
};

export default CrewRecent;
